import { observable, toJS } from "mobx";
import DataStore from "../../../stores/DataStore";
import * as moment from "moment";
import ServicosService from "../services/ServicosService";
import { E_TITULO_TELA, E_TIPO_CLIENTE, E_STATUS_CNTR, E_CG_REF_CODES, E_CONDICAO, E_SENTIDO_OPERACAO, E_TIPO_CNTR, E_TIPO } from './Enum';
import { terminal as TERMINAL } from "../../../config/Constantes";
import cabecalhoRIG from '../../../assets/images/pdf_cabecalho_rig.png'
import cabecalhoSSA from '../../../assets/images/pdf_cabecalho_ssa.png'
import { convertKeyValueToNumber, getBase64ImageFromURL } from "../../../utils/functions";
import SimulacaoServicosCalcStore from "./SimulacaoServicosCalcStore";
import { AvisoImportante } from "./SimulacaoServicosStore";

const cabotagemLayout = {
    DataEntrada: moment().format("YYYY-MM-DD"),
    DataSaida: moment().add(1, 'days').format("YYYY-MM-DD"),
    QtdContainer20: 0,
    QtdContainer40: 0,
    StatusContainer: null,
    Servicos: [],
    Containers: [],
    Erros: {}
};

const containerLayout = {
    Cntr: 0,
    Tipo: null,
    Status: null,
    TipoCntr: null,
    QtdServicoAcessorio: 0,
    Quantidade: 1,
    Especial: false,
    Imo: false,
    Erros: {},
    QtdDue: 0,
    Passagem: false
};

const dadosLabelsCabEmbarque = {
    DtCriacao: "Data Simulação",
    DataEntrada: "Data Entrada",
    DataSaida: "Data Saída",
    QtdCntr: "Qtd. Container",
    QtdImo: "Qtd. Imo",
    QtdEspecial: "Qtd. Especial",
    QtdStatus: "Status do Container",
    QtdTipoCntr: "Tipo de Container",
    QtdIsoCntr: "Tipo",
    RazaoSocial: "Razão Social",
    CnpjTecon: "CNPJ Tecon",
};

const dadosLabelsCabDesembarque = {
    DtCriacao: "Data Simulação",
    DataEntrada: "Data Entrada",
    DataSaida: "Data Saída",
    QtdCntr: "Qtd. Container",
    QtdImo: "Qtd. Imo",
    QtdEspecial: "Qtd. Especial",
    QtdStatus: "Status do Container",
    QtdTipoCntr: "Tipo de Container",
    QtdIsoCntr: "Tipo",
    RazaoSocial: "Razão Social",
    CnpjTecon: "CNPJ Tecon",
};

export default class SimulacaoServicosCabStore extends DataStore {

    // Geral    
    @observable servicos = [];
    @observable loadingServicos = false;
    
    data = this.defaultObj(cabotagemLayout);
    opcoesStatusContainer = this.defaultObj([]);
    opcoesTiposContainer = this.defaultObj([]);
    opcoesTipoCntr = this.defaultObj([]);

    @observable tipoCliente;

    constructor() {
        super();

        this.calcStore = new SimulacaoServicosCalcStore();
    };

    get servicosAgrupados() {
        return this.calcStore.agrupaServicos(this.servicos);
    }

    async fecthOptions(tipoCliente) {
        this.setTipoCliente(tipoCliente);
        try {
            await Promise.all([
                this.fetchAndSetData(this.opcoesTiposContainer, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.IsoCntr),
                this.fetchAndSetData(this.opcoesStatusContainer, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.StatusCntr),
                this.fetchAndSetData(this.opcoesTipoCntr, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.TipoCntr),
            ]);
        } catch (error) {
            console.error(error);
        }
    }

    setTipoCliente(tipoCliente) {
        this.tipoCliente = tipoCliente;
    }

    opcoesTipoCntrFiltradasPorIndex(index) {
        let options = toJS(this.opcoesTipoCntr.value);
        
        const container = toJS(this.data.value.Containers).at(index);

        const filtraBundle = (container.Status && container.Status.value == E_STATUS_CNTR.Cheio) || 
                        this.tipoCliente == E_TIPO_CLIENTE.Carga;

        const filtraOog = TERMINAL == 'SSA' && this.tipoCliente == E_TIPO_CLIENTE.Carga;

        if (filtraBundle) options = options.filter(opt => opt.value != E_TIPO_CNTR.Bundle);
        if (filtraOog) options = options.filter(opt => opt.value != E_TIPO_CNTR.OOG);

        return options;
    }

    disableEspecialOption(index) {
        const { TipoCntr, Status } = toJS(this.data.value.Containers).at(index);

        const isNotDryOrTank = TipoCntr && (TipoCntr.value != E_TIPO_CNTR.Dry && TipoCntr.value != E_TIPO_CNTR.Tank)

        const isTankAndEmpty = TipoCntr && Status && (TipoCntr.value == E_TIPO_CNTR.Tank && Status.value == E_STATUS_CNTR.Vazio)

        return isNotDryOrTank || isTankAndEmpty;
    }

    clearFields = () => {
        this.servicos = [];
        this.data = this.defaultObj(cabotagemLayout);
    }
   
    setItem = (key, newValue, index = null) => {
        let value = newValue;

        this.setValue(this.data, {...this.data.value, [key]: value, ['Erros']: {...this.data.value.Erros, [key]: null} } );     
    }

    addContainer = async (tipoCliente) => {
        const containers = toJS(this.data.value.Containers);
        let numeroCntr = 1;
        let optStatus = null;

        if (containers.length){
            const lastCntr = containers.at(containers.length - 1);
            numeroCntr = +lastCntr.Cntr + 1;
        }

        if (tipoCliente == E_TIPO_CLIENTE.Carga) optStatus = E_STATUS_CNTR.Cheio;

        this.data.value.Containers.push({
            ...containerLayout, 
            Cntr: numeroCntr, 
            Status: optStatus ? optStatus : null
        });
    }

    setContainer = async (index, key, newValue) => {
        const item = this.data.value.Containers.at(index);
        item[key] = newValue;

        item.Erros[key] = null;
        item.Erros['Item'] = null;

        if (key == 'TipoCntr') {
            item.Especial = TERMINAL == "SSA" && newValue.value == E_TIPO_CNTR.FlatOpenTop;
        }

        if (key == 'Status') {
            if (item.TipoCntr && item.TipoCntr.value == E_TIPO_CNTR.Bundle && newValue.value == E_STATUS_CNTR.Cheio) 
                item.TipoCntr = null;
            if (item.TipoCntr && item.TipoCntr.value == E_TIPO_CNTR.Tank && newValue.value == E_STATUS_CNTR.Vazio) 
                item.Especial = false;
        }
    }

    removeContainer = (index, cntr) => {
        this.data.value.Containers = this.data.value.Containers.filter((_, i) => i != index).map((c, index) => ({ ...c, Cntr: index + 1 }));

        const servicos = this.servicos.filter(({ Cntr }) => Cntr != cntr);

        this.servicos = servicos;

    }

    /**
     * Validade and set errors 
     */
    gerarServicos = async(filtros) => {
        const { DataEntrada, DataSaida, Containers } = toJS(this.data.value);

        // validação de campos não preenchidos
        let validacao = 0;
        let validacaoDatas = 0;
        let validacaoDuplicados = 0;

        if (!DataEntrada) {
            this.setValue(this.data, {...this.data.value, ['Erros']: {...this.data.value.Erros, ['DataEntrada']: 'Obrigatório!'}  } );
            validacao++;
        }

        if (!DataSaida) {
            this.setValue(this.data, {...this.data.value, ['Erros']: {...this.data.value.Erros, ['DataSaida']: 'Obrigatório!'}  } );
            validacao++;
        }

        if (moment(DataEntrada).isAfter(DataSaida)) validacaoDatas++;

        Containers.map(async({ Tipo, Status, TipoCntr, Quantidade, Erros, Especial, Imo }, index, arrayCntr) => {

            Erros['Item'] = "";            

            if(!(Tipo && Status && TipoCntr && Quantidade)) {
                validacao++;

                if(!Tipo) Erros['Tipo'] = 'Obrigatório!';
                if(!Status) Erros['Status'] = 'Obrigatório!';
                if(!TipoCntr) Erros['TipoCntr'] = 'Obrigatório!';
                if(!Quantidade) Erros['Quantidade'] = 'Obrig.';
            }
            else {
                arrayCntr.filter((itemArray, indexArray) => {
                    const { Tipo: tipo , Status: status, TipoCntr: tipoCntr , Especial: especial, Imo: imo } = itemArray;

                    if (tipo && status && tipoCntr ){
                        const filtroExtra = TERMINAL === "SSA" ? (imo == Imo) : true;
                        
                        if(Tipo.value == tipo.value && Status == status && TipoCntr.value == tipoCntr.value && index != indexArray && especial == Especial && filtroExtra){
                            validacaoDuplicados++;    

                            Erros['Item'] = 'Item Duplicado!';
                        }
                    }
                });
            }
        });

        this.setValue(this.data, {...this.data.value, ['Containers']: Containers } );

        if (validacao > 0) return { error: true, message: "É Necessário preencher todos os campos!" };
        if (validacaoDatas > 0) return { error: true, message: "Data saída maior que a entrada!" };
        if (validacaoDuplicados > 0) return { error: true, message: "Existem itens duplicados!" };

        return await this.populateServicosBasicos(this.buildRequestBody(filtros, E_CONDICAO.Sim, Containers));
    }

    removeServico = (servico) => {
        const { Cntr: cr, Codigo: cod, CodigoPai: codPai, Qtd: q } = servico;

        const servicosFiltrados = this.servicos.map(servico => {
            const { Codigo, CodigoPai, Cntr } = servico;

            if (Cntr != cr) return servico;

            if (Codigo !== cod && CodigoPai !== cod && Codigo !== codPai) return servico;

            servico.Qtd -= q;

            return servico;
        }).filter(({ Qtd }) => Qtd > 0);

        this.servicos = servicosFiltrados;
    }
    
    removeServicoPorCodigo = (codigo) => {
        this.servicos = this.servicos.filter(s => s.Codigo != codigo);
    }
    
    addServicosAcessorios = async (servicosSelecionados, cntr = 0) => {
        const containers = toJS(this.data.value.Containers);

        let quantidade = 0;

        if (cntr == 0) {
            quantidade = containers.reduce((acc, obj) => (acc + obj.Quantidade), 0);
        } else {
            quantidade = containers.reduce((acc, obj) => (obj.Cntr == cntr ? acc + obj.Quantidade : acc), 0);
        }

        const servicoParaAdicionar = servicosSelecionados.map((serv) => {
            let Qtd = parseInt(serv.Qtd);

            if (serv.Basico != E_CONDICAO.N_a) Qtd = quantidade;

            return ({...serv, Cntr: cntr, Qtd });
        })

        this.servicos = this.calcStore.concatServicos(this.servicos, servicoParaAdicionar);
    }

    resetarServicos = () => {
        this.servicos = [];
    }

    getCntr = (index) => {
        return toJS(this.data.value.Containers).at(index);
    }

    getAllItems = () => {
        return toJS(this.data.value.Containers);
    }

    getFilterForServicosAcessorios = (filtros, cntr = null) => {
        let Container = toJS(this.data.value.Containers);

        if (cntr != null) Container = [ cntr ];

        return this.buildRequestBody(filtros, E_CONDICAO.Nao, Container);
    }

    getServicosIncluidosPorCntr = (cntr) => {
        if (!cntr) return [];

        const { Cntr } = cntr;

        return this.servicos.filter(servico => Cntr == servico.Cntr);
    }

    getServicosIncluidosPorIndex = (index) => {
        return this.getServicosIncluidosPorCntr(this.getCntr(index));
    }

    buildRequestBody = (f, ServicoBasico, Containers = []) => {

        let Processos = [];
        let Itens = [];

        const { DataEntrada, DataSaida } = toJS(this.data.value);

        if (Array.from(Containers).length > 0) {
            Processos = [{
                NumBl: null,
                DataEntrada,
                DataSaida,
                QtdCntr20: Containers.reduce((result, { Tipo, Quantidade }) => result + (Tipo && Tipo.value == E_TIPO.Cntr20 ? Quantidade : 0), 0), 
                QtdCntr40: Containers.reduce((result, { Tipo, Quantidade }) => result + (Tipo && Tipo.value == E_TIPO.Cntr40 ? Quantidade : 0), 0),
                Especial: Containers.find(i => i.Especial) ? E_CONDICAO.Sim : E_CONDICAO.Nao,
                ValorCif: null,
            }];
            Itens = Containers.map(c => this.buildItemRequestBody(f, ServicoBasico, c));
        }
        else {
            Itens = [this.buildItemRequestBody(f, ServicoBasico)];
        }

        return {
            Processos,
            Itens
        }
    }

    buildItemRequestBody = (f, ServicoBasico, container) => {
        let requestBody = {
            Basico: ServicoBasico,
            TipoClienteId: f.tipoCliente,
            ModalidadeId: f.modalidade,
            SentidoOperacaoId: f.sentidoOperacao,
            OrigemCargaId: f.origemCarga,
            TipoRegimeId: null,
            ManualMecanizadaId: null,
            ParcialTotalId: null,
            TipoDeclaracaoId: null,
        };
        
        if (!container) return requestBody;
        
        const { Tipo, Status, TipoCntr, Quantidade, QtdDue, Especial, Imo, Passagem, Cntr } = container;
        
        requestBody = Object.assign(requestBody, 
        {
            NumBl: null,
            Cntr,
            Qtd: Quantidade,
            QtdDue,
            TipoId: Tipo.value,
            StatusId: Status.value,
            TipoCntrId: TipoCntr.value,
            Passagem: Passagem ? 'V' : 'F',
            Especial: Especial ? 'V' : 'F',
            Imo: Imo ? 'V' : 'F',
            Vistoria: null,
            Refrigerada: null,
        });

        return requestBody;
    }

    /**
     * Request to API the services based on filter and set servicos
     */
    populateServicosBasicos = async (requestBody) => {        
        this.loadingServicos = true;

        try {
            const { status , data } = await ServicosService.buscarServicos(requestBody);

            if (status == 200) {               
                this.servicos = this.calcStore.ordenaServicos(data);

                var result = ({
                    status,
                    title: "Sucesso!",
                    message: "Busca realizada com sucesso.",
                    error: false
                });
            }
            else {
                var result = ({
                    status,
                    title: "Erro!",
                    message: data.Message || "Ocorreu um erro!",
                    error: true
                });
            }

            return result;

        } catch (error) {
            console.log("Error -> : ", error);

            return ({
                status: 500,
                title: "Erro!",
                message: error || "Ocorreu um erro na busca.",
                error: true
            });
        
        } finally {
            this.loadingServicos = false;
        }
    }

    calcularSimulacao = async ({ tipoCliente, sentidoOperacao, ehNacional }) => {
        try {
            const convertKeyValueToString = (list, key, subKey = '', descricao = '') => {
            
                const arrayReduce = list.reduce((acc, obj) => {
                    const keyDesc = descricao + (subKey ? obj[key][subKey] : obj[key]);
            
                    acc[keyDesc] = acc[keyDesc] ? acc[keyDesc] + obj['Quantidade'] : obj['Quantidade'];
                    
                    return acc
                },{});
            
                return Object.keys(arrayReduce).map(key => `${key}: ${arrayReduce[key]}`).join(', ');
            }

            const convertLabels = (keys, dadosLabel) => {
                const labels = [];

                Object.keys(dadosLabel).map(label => {
                    const chave = dadosLabel[label];
                    const valor = keys[label];

                    if(chave && valor && !(tipoCliente != E_TIPO_CLIENTE.Armador && label == 'QtdStatus')) {
                        if (['QtdIsoCntr','QtdStatus','QtdTipoCntr'].includes(label)) {
                            valor.split(',').map(obj => {
                                const array = obj.split(':');
                                labels.push( [array[0].trim() , array[1].trim() ]);
                            });
                        }
                        else {
                            let newValue = valor;

                            if (['DataEntrada','DataSaida'].includes(label)) 
                                newValue = moment(valor).format("DD/MM/YYYY");

                            if (['DtCriacao'].includes(label)) 
                                newValue = moment(valor).format("DD/MM/YYYY HH:mm");

                            labels.push([ chave, newValue ]);
                        }
                    }
                });
                
                return labels;
            }
            
            const { DataEntrada, DataSaida, Containers } = toJS(this.data.value);

            const newSimulation = {
                DataEntrada,
                DataSaida,
                EhNacional: ehNacional,
                QtdEspecial: convertKeyValueToNumber(Containers, 'Quantidade', 'Especial'),
                QtdImo: convertKeyValueToNumber(Containers, 'Quantidade', 'Imo'),
                QtdCntr: convertKeyValueToNumber(Containers, 'Quantidade'),
                QtdIsoCntr: convertKeyValueToString(Containers, 'Tipo', 'label', 'Container-'),
                QtdStatus: convertKeyValueToString(Containers, 'Status', 'label', 'Status-'),
                QtdTipoCntr: convertKeyValueToString(Containers, 'TipoCntr', 'label'),
                Servicos: []
            };

            toJS(this.servicos).map(({  NumBl, Cntr: cntr, Codigo, ClassificacaoId, Qtd, QtdCntr20, QtdCntr40, ValorCif, Especial, Imo, Oog }) => {

                const container = Containers.find(({ Cntr }) => Cntr == cntr);

                newSimulation.Servicos.push({
                    NumBl, Cntr: cntr,
                    ClassificacaoId,
                    Especial,
                    Imo: Imo == E_CONDICAO.Sim && container && (TERMINAL === "RIG" ? container.Especial : container.Imo) ? E_CONDICAO.Sim : E_CONDICAO.Nao,
                    Oog,
                    Codigo, 
                    Qtd,
                    QtdCntr20, QtdCntr40, ValorCif,
                })
            });

            console.log('### newSimulation: ', newSimulation);
            
            const { status, data } = await ServicosService.gerarSimulacao(newSimulation);

            const { data: dadosTerminal } = await ServicosService.buscarDadosTerminal(); 

            if (status == 200) {
                
                const dadosLabel = E_SENTIDO_OPERACAO.Embarque == sentidoOperacao ? 
                    convertLabels(data, dadosLabelsCabEmbarque) : 
                    convertLabels(data, dadosLabelsCabDesembarque);

                const url = TERMINAL === "RIG" ? cabecalhoRIG : cabecalhoSSA;

                const dadosModalidade = {
                    ...data, 
                    loading: false, 
                    AvisoImportante, 
                    Titulo: `Simulação ${E_TITULO_TELA.Cabotagem}`, 
                    dadosLabel,
                    dadosProcessos: [],
                    pdfHeaderImage: await getBase64ImageFromURL(url),
                    dadosTerminal,
                };

                var result = ({
                    status,
                    title: "Sucesso!",
                    message: "Cálculo realizado com sucesso.",
                    dadosModalidade,
                });
            }
            else {
                var result = ({
                    status,
                    title: "Erro!",
                    message: data.Message || "Ocorreu um erro!",
                });
            }

            return result;

        } catch (error) {
            console.log("Error -> : ", error);

            return ({
                status: 500,
                title: "Erro!",
                message: error || "Ocorreu um erro na simulação.",
            });
        } 
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosCabStore.js